import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  mode: "light",
  user: null,
  token: null,
  openLabelsDrawer: false,
  triggerRefresh: false,
  viewByLabel: "noun",
  viewBySearchTerm: "",
  refreshKey: 0,
}

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light"
    },
    setLogin: (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token
    },
    setLogout: (state) => {
      state.user = null
      state.token = null
    },
    setOpenLabelsDrawer: (state, action) => {
      state.openLabelsDrawer = action.payload.openLabelsDrawer
    },
    setTriggerRefresh: (state, action) => {
      state.triggerRefresh = action.payload.triggerRefresh
    },
    setViewByLabel: (state, action) => {
      state.viewByLabel = action.payload.viewByLabel
    },
    setViewBySearchTerm: (state, action) => {
      state.viewBySearchTerm = action.payload.viewBySearchTerm
    },
    setRefreshKey: (state, action) => {
      state.refreshKey = action.payload.refreshKey
    },
  }
})

export const {
  setMode,
  setLogin,
  setLogout,
  setOpenLabelsDrawer,
  setTriggerRefresh,
  setViewByLabel,
  setViewBySearchTerm,
  setRefreshKey
} = appSlice.actions
export default appSlice.reducer